import { Injectable } from '@angular/core';
import { FantasyLeaderboardStore } from './fantasy-leaderboard.store';
import { ApiService } from '../../shared/services/core/api.service';
import { tap, mapTo } from 'rxjs/operators';
import { FantasyLeaderboard } from './models/fantasy-leaderboard.model';

@Injectable({ providedIn: 'root' })
export class FantasyLeaderboardService {

  constructor(private fantasyLeaderboardStore: FantasyLeaderboardStore,
              private api: ApiService) {
  }

  fetchMonthlyLeaderboard(amountToDisplay: number) {
    return this.api.get<FantasyLeaderboard>('fantasy/leaderboard/monthly/' + amountToDisplay).pipe(
      tap(entries => {
        this.fantasyLeaderboardStore.update(state => ({ monthlyLeaderboard: entries }));
      }),
      mapTo(null)
    );
  }

  fetchYearlyLeaderboard(amountToDisplay: number) {
    return this.api.get<FantasyLeaderboard>('fantasy/leaderboard/yearly/' + amountToDisplay).pipe(
      tap(entries => {
        this.fantasyLeaderboardStore.update(state => ({ yearlyLeaderboard: entries }));
      }),
      mapTo(null)
    );
  }
}
